<template>
	<div class="word-classroom-page">
		<header class="word-classroom-toolbar">
			<button type="button" class="toolbar-button" @click="goHome">
				<i class="el-icon-arrow-left"></i>
				返回首页
			</button>
			<div class="toolbar-title">
				<strong>智慧课堂</strong>
				<span>优点英语词汇课堂</span>
			</div>
			<button type="button" class="toolbar-button" @click="toggleFullscreen">
				<i :class="isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen'"></i>
				{{ isFullscreen ? '退出全屏' : '课堂全屏' }}
			</button>
		</header>

		<main ref="classroomShell" class="word-classroom-shell">
			<div v-if="loading" class="classroom-status">
				<i class="el-icon-loading"></i>
				<span>正在进入智慧课堂…</span>
			</div>
			<div v-if="loadFailed" class="classroom-status classroom-status-error">
				<strong>智慧课堂暂时无法打开</strong>
				<span>请确认单词领读网页版已经发布，或检查课堂地址配置。</span>
				<button type="button" @click="reloadClassroom">重新加载</button>
			</div>
			<iframe
				:key="frameKey"
				ref="classroomFrame"
				class="word-classroom-frame"
				:src="classroomUrl"
				title="优点英语词汇课堂"
				allow="autoplay; fullscreen; clipboard-read; clipboard-write"
				allowfullscreen
				scrolling="no"
				@load="handleFrameLoad"
			></iframe>
		</main>
	</div>
</template>

<script>
export default {
	name: 'wordClassroom',
	data() {
		return {
			loading: true,
			loadFailed: false,
			frameKey: 0,
			isFullscreen: false,
			loadTimer: null
		};
	},
	computed: {
		classroomUrl() {
			const configuredUrl = process.env.VUE_APP_WORD_CLASSROOM_URL;
			if (configuredUrl) return configuredUrl;
			const baseUrl = process.env.BASE_URL || '/';
			return `${baseUrl.replace(/\/?$/, '/')}word-classroom/index.html`;
		}
	},
	mounted() {
		document.addEventListener('fullscreenchange', this.syncFullscreenState);
		this.startLoadTimer();
	},
	beforeDestroy() {
		document.removeEventListener('fullscreenchange', this.syncFullscreenState);
		this.clearLoadTimer();
	},
	methods: {
		goHome() {
			this.$router.push('/home');
		},
		startLoadTimer() {
			this.clearLoadTimer();
			this.loading = true;
			this.loadFailed = false;
			this.loadTimer = window.setTimeout(() => {
				if (this.loading) {
					this.loading = false;
					this.loadFailed = true;
				}
			}, 12000);
		},
		clearLoadTimer() {
			if (this.loadTimer) {
				window.clearTimeout(this.loadTimer);
				this.loadTimer = null;
			}
		},
		handleFrameLoad() {
			this.clearLoadTimer();
			this.loading = false;
			this.loadFailed = false;
		},
		reloadClassroom() {
			this.frameKey += 1;
			this.startLoadTimer();
		},
		syncFullscreenState() {
			this.isFullscreen = document.fullscreenElement === this.$refs.classroomShell;
		},
		async toggleFullscreen() {
			const shell = this.$refs.classroomShell;
			if (!shell) return;
			try {
				if (document.fullscreenElement) {
					await document.exitFullscreen();
				} else {
					await shell.requestFullscreen();
				}
			} catch (error) {
				this.$message.error('当前浏览器未允许进入全屏，请重试。');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.word-classroom-page {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	height: 100dvh;
	min-width: 0;
	background: #eef3f0;
	overflow: hidden;
}

.word-classroom-toolbar {
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 0 0 54px;
	padding: 0 18px;
	background: #ffffff;
	border-bottom: 1px solid #dce7e0;
	box-shadow: 0 2px 10px rgba(19, 76, 43, 0.08);
}

.toolbar-title {
	display: flex;
	align-items: baseline;
	gap: 12px;
	color: #176f39;

	strong {
		font-size: 20px;
		font-weight: 600;
	}

	span {
		font-size: 13px;
		color: #829288;
	}
}

.toolbar-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 7px;
	height: 34px;
	min-width: 94px;
	padding: 0 14px;
	border: 1px solid #c9ddd0;
	border-radius: 6px;
	background: #ffffff;
	color: #176f39;
	font-size: 14px;
	cursor: pointer;

	&:hover {
		background: #edf8f1;
		border-color: #7db993;
	}
}

.word-classroom-shell {
	position: relative;
	flex: 1;
	min-height: 0;
	background: #102e25;
}

.word-classroom-frame {
	display: block;
	width: 100%;
	height: 100%;
	border: 0;
	background: #f5f7f6;
}

.classroom-status {
	position: absolute;
	inset: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	background: #f5f8f6;
	color: #436050;
	font-size: 15px;

	i {
		font-size: 28px;
		color: #188346;
	}
}

.classroom-status-error {
	strong {
		font-size: 18px;
		color: #2d4637;
	}

	span {
		color: #738279;
	}

	button {
		margin-top: 6px;
		padding: 8px 20px;
		border: 0;
		border-radius: 5px;
		background: #188346;
		color: #ffffff;
		cursor: pointer;
	}
}

.word-classroom-shell:fullscreen {
	width: 100vw;
	height: 100vh;
}

@media (max-width: 1100px) {
	.toolbar-title span {
		display: none;
	}
}
</style>
